// src/utils/loadJS.js
/*! loadJS: load a JS file asynchronously. [c]2014 @scottjehl, Filament Group, Inc. (Based on http://goo.gl/REQGQ by Paul Irish). Licensed MIT */

(function (w) {
  const loadJS = function (src, cb, ordered) {
    // Handle parameter swapping without reassignment
    let callback = cb;
    let isOrdered = ordered;

    if (typeof cb === "boolean") {
      isOrdered = cb;
      callback = ordered;
    }

    const ref = w.document.getElementsByTagName("script")[0];
    const script = w.document.createElement("script");

    script.src = src;
    script.async = !isOrdered;

    // Add error handling and cleanup
    if (callback && typeof callback === "function") {
      const cleanup = () => {
        script.onload = null;
        script.onerror = null;
      };

      script.onload = function () {
        cleanup();
        callback(null, script);
      };

      script.onerror = function () {
        cleanup();
        callback(new Error(`Failed to load script: ${src}`), script);
      };
    }

    // Insert script into DOM
    if (ref && ref.parentNode) {
      ref.parentNode.insertBefore(script, ref);
    } else {
      // Fallback if no script tag exists
      w.document.head.appendChild(script);
    }

    return script;
  };

  // commonjs
  if (typeof module !== "undefined") {
    module.exports = loadJS;
  } else {
    // Assign to window without mutating the parameter
    const global = w;
    global.loadJS = loadJS;
  }
})(typeof global !== "undefined" ? global : this);
